(function (requirejs, document) {
  'use strict';
  function getLanguage() {
    try {
      return document.getElementsByTagName("html").item(0).attributes.getNamedItem("lang").value;
    } catch(e) {
      if(console && console.log) {
        console.log("Error discovering language", e);
      }
      return "de";
    }
  }
  var lang = getLanguage();

  requirejs.config({
    shim: {
      'jsroutes': {
        deps: [ 'jquery' ], // as it references jQuery.ajax
        // it's not a RequireJS module, so we have to tell it what var is returned
        exports: 'jsRoutes'
      },
      'ishop-play-commons/vendor/jquery.serializejson': {
        deps: [ 'jquery' ]
      // exported via jquery object
      },
      'ishop-play-commons/vendor/ractive-adaptors-backbone': {
        deps: [ 'backbone', 'ractive' ]
      // exported via jquery object
      },
      'bacon': {
        deps: [ 'jquery' ]
      },
      'responsiveslides': {
        deps: [ 'jquery' ]
      },
      'bootstrap': {
        deps: [ 'jquery' ]
      },
      'footable': {
        deps: [ 'jquery' ]
      },
      'footable.paginate': {
          deps: [ 'footable' ]
      },
      'footable.sort': {
        deps: [ 'footable' ]
      },
      'footable.striping': {
        deps: [ 'footable' ]
      },
      'footable.filter': {
        deps: [ 'footable' ]
      },
      'ishop-commons/vendor/lightbox': {
        deps: [ 'jquery' ]
      }
    },

    // no timeout
    waitSeconds: 0,

    paths: {
      'shop/configuration': [ '/javascriptConfiguration' ],

      // generated messages
      'shop/messages': [ '/'+lang+'/javascriptMessages' ],

      // generated routes
      'shop/routes': [ '/'+lang+'/jsroutes' ],
      'shop/authentication/routes': [ '/'+lang+'/authentication/javascriptRoutes' ],
      'shop/orderprocess/routes': [ '/'+lang+'/orderprocess/javascriptRoutes' ],
      'shop/catalog/routes': [ '/'+lang+'/catalogjsroutes' ],
      'shop/watchlist/routes': [ '/'+lang+'/watchlist/javascriptRoutes' ],
      'shop/examples/routes': [ '/'+lang+'/examples/javascriptRoutes' ],
      'shop/comparelist/routes': [ '/'+lang+'/comparelist/javascriptRoutes' ],

      'commons': [ '/commons' ],
      'jquery': "//cdn.jsdelivr.net/webjars/jquery/3.5.0/jquery.min",
      'ractive': "//cdn.jsdelivr.net/webjars/ractive/0.7.1/ractive.min",
      'underscore': "//cdn.jsdelivr.net/webjars/underscorejs/1.8.3/underscore-min",
      'backbone': "//cdn.jsdelivr.net/webjars/backbonejs/1.2.1/backbone-min",
      'mustache': "//cdn.jsdelivr.net/webjars/mustachejs/0.8.2/mustache",
      'backbonelocalstorage': "//cdn.jsdelivr.net/webjars/backbone-localstorage/1.1.0/backbone.localStorage-min",
      'jquery.form': "//cdn.jsdelivr.net/webjars/jquery-form/3.51/jquery.form",
      'jquery-ui': "//cdn.jsdelivr.net/webjars/jquery-ui/1.12.1/jquery-ui.min",
      'semantic-ui': "../lib/semantic-ui/semantic-ui",
      'bootstrap': "//cdn.jsdelivr.net/webjars/bootstrap/3.3.4/js/bootstrap.min",
      'jquery-validation': "//cdn.jsdelivr.net/webjars/jquery-validation/1.13.1/jquery.validate.min",
      'bacon': '../lib/baconjs/dist/Bacon',
      'footable': 'shop/footable/footable.custom',
      'footable.paginate': 'shop/footable/footable.paginate',
      'footable.sort': 'shop/footable/footable.sort.custom',
      'footable.striping': 'shop/footable/footable.striping.custom',
      'footable.filter': 'shop/footable/footable.filter.custom',
      'dropdown-fix': 'dropdown-fix',

      // assets from submodules are exported in webjar style (into target/web/rjs/build path)
      'ishop-commons': "../lib/ishop-play-commons/javascripts",
      'ishop-orderprocess': "../lib/ishop-play-orderprocess/javascripts",
      'ishop-catalog': "../lib/ishop-play-catalog/javascripts",
      'ishop-watchlist': '../lib/ishop-play-watchlist/javascripts',
      'ishop-examples': '../lib/ishop-play-examples/javascripts',
      'ishop-comparelist': '../lib/ishop-play-comparelist/javascripts'
    }
  });

})(requirejs, window.document);

define("main", function(){});

